import { render, staticRenderFns } from "./ProductHighlights.vue?vue&type=template&id=18d4b505&scoped=true&"
import script from "./ProductHighlights.vue?vue&type=script&lang=js&"
export * from "./ProductHighlights.vue?vue&type=script&lang=js&"
import style0 from "./ProductHighlights.vue?vue&type=style&index=0&id=18d4b505&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d4b505",
  null
  
)

export default component.exports